export const TRANSACTION_ROW_ICON_SIZE_PX = 24;
